import React from 'react';
import { Draggable, Droppable } from '@hello-pangea/dnd';
import { ContentBlockIcon, DividerIcon, DragIcon } from 'assests/GmsIcons';
import { Widget } from '../ui';

type WidgetSectionProps = {
    className?: string;
    title?: string;
    onWidgetClick?: (widget: Widget) => void;
    onDragHandleClick?: (widget: Widget) => void;
}

const WidgetSection: React.FC<WidgetSectionProps> = ({
    className = '',
    title = 'Widget',
    onWidgetClick,
    onDragHandleClick,
}) => {
    const widgets: Widget[] = [
        {
            id: 'content-block',
            type: 'content-block',
            icon: ContentBlockIcon,
            label: 'Content Block'
        },
        {
            id: 'divider',
            type: 'divider',
            icon: DividerIcon,
            label: 'Divider'
        }
    ];

    return (
        <div className={`tw-h-auto tw-pt-2 tw-border-t tw-border-solid tw-border-[#E5E5EA] ${className}`}>
            <h4 className="tw-text-[#090A42] tw-font-semibold tw-text-sm">{title}</h4>
            <Droppable droppableId="controls_droppable" type="controls" isDropDisabled={true}>
                {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        <div className="tw-flex tw-flex-row tw-gap-2 tw-mt-2">
                            {widgets.map((widget, index) => (
                                <Draggable 
                                    key={`widget_${widget.id}`}
                                    draggableId={JSON.stringify({
                                        id: widget.id,
                                        type: widget.type,
                                        name: widget.label,
                                        isWidget: true,
                                        targetType: 'submodel',
                                        content: '',        
                                        isEditing: false
                                    })}
                                    index={-1}
                                >
                                    {(provided, snapshot) => (
                                        <div role="button" data-testid={`components-widgetsection-div-1-${index}`}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className="tw-w-[50%] tw-h-[28px] tw-p-1 tw-bg-white tw-border tw-border-[#dadbdd]"
                                            onClick={() => onWidgetClick?.(widget)}
                                        >
                                            <div className="tw-flex tw-h-full tw-items-center tw-px-2 tw-gap-3">
                                                <div aria-label="Drag" role="button" data-testid={`components-widgetsection-div-2-${index}`} 
                                                    className="tw-cursor-move"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onDragHandleClick?.(widget);
                                                    }}
                                                >
                                                    <DragIcon />
                                                </div>
                                                <div className="tw-flex tw-items-center tw-gap-2">
                                                    <widget.icon />
                                                    <span className="tw-text-[#172B4D] tw-text-xs">
                                                        {widget.label}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    </div>
                )}
            </Droppable>
        </div>
    );
};

export default WidgetSection;